import { NgModule } from '@angular/core';
import { YandexMapComponent } from './yandex-map.component';

@NgModule({
  declarations: [YandexMapComponent],
  exports: [YandexMapComponent],
})
export class YandexMapModule {}
